import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrashCan, faLock, faUnlock } from "@fortawesome/free-solid-svg-icons";
import "./sidebarDraftManager.css";

export default function SidebarDraftManager({
  isSidebarOpen,
  toggleSidebar,
  visibleDrafts,
  scheduledDrafts,
  articles,
  user,
  handleEditDraft,
  handleEditArticle,
  handleSwitchToPublish,
  handleSwitchToDraft,
  setDeleteType,
  setConfirmDeleteId,
}) {
  return (
    <>
      <div
        className={`dimmed-background ${isSidebarOpen ? "visible" : ""}`}
        onClick={toggleSidebar}
      ></div>

      <div className={`sidebar ${isSidebarOpen ? "open" : "closed"}`}>
        <button className="sidebar-toggle" onClick={toggleSidebar}>
          {isSidebarOpen ? "→" : "←"}
        </button>
        <div className="sidebar-content">
          <div className="DraftManagement">
            <h2 style={{ textAlign: "center" }}>Drafts</h2>
            <ul>
              {visibleDrafts.length > 0 && (
                <li
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontWeight: "bold",
                    paddingBottom: "8px",
                  }}
                >
                  <div style={{ display: "flex", gap: "10px", flex: 1, minWidth: 0 }}>
                    <span style={{ flexGrow: 1, flexShrink: 1, textDecoration: "none", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>Created On</span>
                    <span style={{ flexGrow: 1, flexShrink: 1, textDecoration: "none", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", marginLeft: "34px" }}>Title</span>
                    <span style={{ width: "200px", minWidth: "200px" }}>Author</span>
                    <span style={{ width: "200px", minWidth: "200px" }}>Editor</span>
                  </div>
                  <div style={{ textAlign: "right", marginRight: "26px" }}>Actions</div>
                </li>
              )}
              {visibleDrafts.map((draft) => (
                <li
                  key={draft._id}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div style={{ display: "flex", gap: "10px", flex: 1, minWidth: 0 }}>
                    <span
                      style={{
                        flexGrow: 1,
                        flexShrink: 1,
                        textDecoration: "none",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                      title={new Date(draft.createdAt).toLocaleString("en-US", {
                              dateStyle: "medium",
                              timeStyle: "short",
                            })}
                    >
                      {new Date(draft.createdAt).toLocaleString("en-US", {
                        dateStyle: "medium",
                        timeStyle: "short",
                      })}
                    </span>
                    <span
                      style={{
                        flexGrow: 1,
                        flexShrink: 1,
                        textDecoration: "none",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                      title={draft.title}
                    >
                      {draft.title}
                    </span>
                    <span
                      style={{
                        width: "200px", // fixed width for author column
                        minWidth: "200px",
                        textDecoration: "none",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                      title={draft.authorName}
                    >
                      {draft.authorName || "Unknown"}
                    </span>
                    <span
                      style={{
                        width: "200px", // fixed width for editor column
                        minWidth: "200px",
                        textDecoration: "none",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                      title={draft.editorName}
                    >
                      {draft.editorName ? (
                        draft.editorName
                      ) : (
                        <span style={{ display: "inline-block", width: "50%", textAlign: "center" }}>–</span>
                      )}
                    </span>
                  </div>
                  <div className="sideBarIcons" style={{ textAlign: "right" }}>
                    <FontAwesomeIcon
                      icon={faPenToSquare}
                      style={{
                        marginRight: "15px",
                        fontSize: "20px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleEditDraft(draft.post_slug)}
                    />
                    {user?.role >= 4 && (
                      <>
                        <FontAwesomeIcon
                          icon={faTrashCan}
                          style={{
                            marginRight: "15px",
                            fontSize: "20px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setDeleteType("draft");
                            setConfirmDeleteId(draft._id);
                          }}
                        />
                        <FontAwesomeIcon
                          icon={faLock}
                          style={{
                            fontSize: "20px",
                            cursor: "pointer",
                          }}
                          onClick={() => handleSwitchToPublish(draft._id)}
                        />
                      </>
                    )}
                  </div>
                </li>
              ))}
            </ul>
            {visibleDrafts.length === 0 && (
              <li style={{ listStyleType: "none", textAlign: "center", paddingTop: "20px", paddingBottom: "20px", fontStyle: "italic" }}>
                No drafts yet.
              </li>
            )}
          </div>

          <div className="ScheduledArticles">
            <h2 style={{ textAlign: "center" }}>Scheduled Articles</h2>
            <ul>
              {scheduledDrafts.length > 0 && (
                <li
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontWeight: "bold",
                    paddingBottom: "8px",
                  }}
                >
                  <div style={{ display: "flex", gap: "10px", flex: 1, minWidth: 0 }}>
                    <span style={{ flexGrow: 1, flexShrink: 1, textDecoration: "none", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>Scheduled For</span>
                    <span style={{ flexGrow: 1, flexShrink: 1, textDecoration: "none", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", marginLeft: "20px" }}>Title</span>
                    <span style={{ width: "200px", minWidth: "200px" }}>Author</span>
                    <span style={{ width: "200px", minWidth: "200px" }}>Editor</span>
                  </div>
                  <div style={{ textAlign: "right", marginRight: "26px" }}>Actions</div>
                </li>
              )}
              {scheduledDrafts.map((draft) => (
                <li
                  key={draft._id}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div style={{ display: "flex", gap: "10px", flex: 1, minWidth: 0 }}>
                    <span
                      style={{
                        flexGrow: 1,
                        flexShrink: 1,
                        textDecoration: "none",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                      title={new Date(draft.scheduledAt).toLocaleString("en-US", {
                              dateStyle: "medium",
                              timeStyle: "short",
                            })}
                    >
                      {new Date(draft.scheduledAt).toLocaleString("en-US", {
                        dateStyle: "medium",
                        timeStyle: "short",
                      })}
                    </span>
                    <span
                      style={{
                        flexGrow: 1,
                        flexShrink: 1,
                        textDecoration: "none",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                      title={draft.title}
                    >
                      {draft.title}
                    </span>
                    <span
                      style={{
                        width: "200px", // fixed width for author column
                        minWidth: "200px",
                        textDecoration: "none",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                      title={draft.authorName}
                    >
                      {draft.authorName || "Unknown"}
                    </span>
                    <span
                      style={{
                        width: "200px", // fixed width for editor column
                        minWidth: "200px",
                        textDecoration: "none",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                      title={draft.editorName}
                    >
                      {draft.editorName ? (
                        draft.editorName
                      ) : (
                        <span style={{ display: "inline-block", width: "50%", textAlign: "center" }}>–</span>
                      )}
                    </span>
                  </div>
                  <div className="sideBarIcons" style={{ textAlign: "right" }}>
                    {user?.role >= 4 && (
                      <>
                        <FontAwesomeIcon
                          icon={faPenToSquare}
                          style={{
                            marginRight: "15px",
                            fontSize: "20px",
                            cursor: "pointer",
                          }}
                          onClick={() => handleEditDraft(draft.post_slug)}
                        />
                        <FontAwesomeIcon
                          icon={faTrashCan}
                          style={{
                            marginRight: "15px",
                            fontSize: "20px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setDeleteType("draft");
                            setConfirmDeleteId(draft._id);
                          }}
                        />
                        <FontAwesomeIcon
                          icon={faLock}
                          style={{
                            fontSize: "20px",
                            cursor: "pointer",
                          }}
                          onClick={() => handleSwitchToPublish(draft._id)}
                        />
                      </>
                    )}
                  </div>
                </li>
              ))}
            </ul>
            {scheduledDrafts.length === 0 && (
              <li style={{ listStyleType: "none", textAlign: "center", paddingTop: "20px", paddingBottom: "20px", fontStyle: "italic" }}>
                No scheduled articles yet.
              </li>
            )}
          </div>

          <div className="ArticleList">
            <h2 style={{ textAlign: "center" }}>Published Articles</h2>
            <div>
              <ul>
                <li
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontWeight: "bold",
                    paddingBottom: "8px",
                  }}
                >
                  <div style={{ display: "flex", gap: "10px", flex: 1, minWidth: 0 }}>
                    <span style={{ flexGrow: 1, flexShrink: 1, textDecoration: "none", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>Published On</span>
                    <span style={{ flexGrow: 1, flexShrink: 1, textDecoration: "none", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>Title</span>
                    <span style={{ width: "200px", minWidth: "200px" }}>Author</span>
                    <span style={{ width: "200px", minWidth: "200px" }}>Editor</span>
                  </div>
                  <div style={{ textAlign: "right", marginRight: "26px" }}>Actions</div>
                </li>
                {articles.map((art) => (
                  <li
                    key={art._id}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "5px",
                    }}
                  >
                    <div style={{ display: "flex", gap: "10px", flex: 1, minWidth: 0 }}>
                      <span
                        style={{
                          flexGrow: 1,
                          flexShrink: 1,
                          textDecoration: "none",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                        title={
                          art.publishedAt && !isNaN(new Date(art.publishedAt).getTime())
                            ? new Date(art.publishedAt).toLocaleString("en-US", {
                              dateStyle: "medium",
                              timeStyle: "short",
                            })
                          : "–"
                        }
                      >
                        {art.publishedAt && !isNaN(new Date(art.publishedAt).getTime())
                          ? new Date(art.publishedAt).toLocaleString("en-US", {
                            dateStyle: "medium",
                            timeStyle: "short",
                          })
                        : "–"}
                      </span>
                      <Link
                        to={`/${art.post_slug}`}
                        style={{
                          flexGrow: 1,
                          flexShrink: 1,
                          textDecoration: "none",
                          color: "#007bff",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                        title={art.title}
                      >
                        {art.title}
                      </Link>
                      <Link
                        to={`/author/${art.authorId}`}
                        style={{
                          width: "200px", // fixed width for author column
                          minWidth: "200px",
                          textDecoration: "none",
                          color: "#007bff",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                        title={art.authorName}
                      >
                        {art.authorName || "Unknown"}
                      </Link>
                      <span
                        style={{
                          width: "200px", // fixed width for editor column
                          minWidth: "200px",
                          textDecoration: "none",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                        title={art.editorName}
                      >
                        {art.editorName ? (
                          art.editorName
                        ) : (
                          <span style={{ display: "inline-block", width: "50%", textAlign: "center" }}>–</span>
                        )}
                      </span>
                    </div>
                    <div
                      className="sideBarIcons"
                      style={{ textAlign: "right" }}
                    >
                      {user?.role >= 4 && (
                        <>
                          <FontAwesomeIcon
                            icon={faPenToSquare}
                            style={{
                              marginRight: "15px",
                              fontSize: "20px",
                              cursor: "pointer",
                            }}
                            onClick={() => handleEditArticle(art.post_slug)}
                          />
                          <FontAwesomeIcon
                            icon={faTrashCan}
                            style={{
                              marginRight: "15px",
                              fontSize: "20px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setDeleteType("article");
                              setConfirmDeleteId(art._id);
                            }}
                          />
                          <FontAwesomeIcon
                            icon={faUnlock}
                            style={{
                              fontSize: "20px",
                              cursor: "pointer",
                            }}
                            onClick={() => handleSwitchToDraft(art._id)}
                          />
                        </>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
